import React, { FC, ReactElement } from 'react';
import { ContentCont, ContentSubText, ContentText } from './DeleteConfirmationModal.styles';
import Modal from '../Modal/Modal';

export interface IDeleteConfirmationModal {
  active: boolean;
  actionLabel: string;
  cancelLabel: string;
  children?: ReactElement;
  title: string;
  text?: string;
  description?: string;
  onConfirm: () => void;
  onClose: () => void;
}

const DeleteConfirmationModal: FC<IDeleteConfirmationModal> = ({
  active,
  actionLabel,
  cancelLabel,
  children,
  title,
  text,
  description,
  onConfirm,
  onClose
}) => (
  <Modal
    active={active}
    title={title}
    width="480px"
    buttonNames={{ action: actionLabel, cancel: cancelLabel }}
    callToAction={onConfirm}
    closeModal={onClose}
    top='150px'
  >
    <ContentCont data-testid="modal-content">
      {children || (
        <>
          <ContentText>{text}</ContentText>
          {description && <ContentSubText>{description}</ContentSubText>}
        </>
      )}
    </ContentCont>
  </Modal>
);

export default DeleteConfirmationModal;
